<template>
  <div class="home">
    <LoginButton />
  </div>
</template>

<script>
// @ is an alias to /src
import LoginButton from '@/components/LoginButton';

export default {
  name: 'home',
  components: {
    LoginButton
  },
  mounted() {
    // clean up localStorage if the user ends up on the Home page
    // this seems to improve login reliability
    localStorage.removeItem('vuex');
    Array.from(localStorage).forEach((s, index) => {
      const lowerKey = localStorage.key(index).toLowerCase();
      console.log(lowerKey);
      if (!lowerKey.includes('cognito') && !lowerKey === 'lastRecord') {
        localStorage.removeItem(localStorage.key(index));
      }
    });
  }
};
</script>
<style scoped>
.home {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
}
</style>
